import { Activity, AlertTriangle, Award, Bell, DollarSign, GitHub, Headphones, Heart, Link2, Mail, Music, Settings } from "react-feather";

export const BadgesContextualSubTitle = [
  {
    text: "Use ",
    code: ".badge ",
  },
  {
    text: "class to make more badges.",
  },
];

export const PillsContextualSubTitle = [
  {
    text: "Use ",
    code: ".rounded-pill",
  },
  {
    text: " class to make badges with background (badge-*) more rounded with a larger ",
    code: "border-radius",
  },
  {
    text: ".",
  },
];

export const NumberPillsSubTitle = [
  {
    text: "Use ",
    code: ".rounded-circle",
  },
  {
    text: " class to make rounded badges with numbers.",
  },
];

export const NumberPillsIconSubTitle = [
  {
    text: "Use ",
    code: ".rounded-circle",
  },
  {
    text: " class to make rounded badges with icon.",
  },
];

export const BadgeWithIconSubTitle = [
  {
    text: "Use the",
    code: ".badge ",
  },
  {
    text: "utility class to make more icons.",
  },
];

export const NumberBadgeSubTitle = [
  {
    text: "Use ",
    code: ".badge",
  },
  {
    text: " class to make square badges with numbers.",
  },
];

export const NumberBadgeIconSubTitle = [
  {
    text: "Use ",
    code: ".badge",
  },
  {
    text: " class to make square badges with icons.",
  },
];

export const RoundedPillSubTitle = [
  {
    text: "Use the",
    code: ".rounded-pill",
  },
  {
    text: " utility class to make icons badges more rounded with a larger ",
    code: "border-radius",
  },
  {
    text: ".",
  },
];

export const BadgeHeadingSubTitle = [
  {
    text: "All html headings,",
    code: " <h1> ",
  },
  {
    text: "through",
    code: " <h6> ",
  },
  {
    text: ", are available in",
    code: " .badge ",
  },
  {
    text: "tags.",
  },
];

export const PositionedBadgesSubTitle = [
  {
    text: "Use utilities to modify a",
    code: ".badge",
  },
  {
    text: " and position it in the corner of a link or button.",
  },
];

export const ButtonBadgesSubTitle = [
  {
    code: ".badge",
  },
  {
    text: " can be used as part of links or buttons to provide a counter.",
  },
];

export const ImageBadgesSubTitle = [
  {
    text: "Use ",
    code: ".badge ",
  },
  {
    text: "class to set image sizes.",
  },
];

export const CloseBadgesSubTitle = [
  {
    text: "Use ",
    code: ".badge-l- ",
  },
  {
    text: "classes to provide background-colors and",
    code: "border-* ",
  },
  {
    text: "classes to provide border-colors.",
  },
];

export const ImageWithCloseBadgesSubTitle = [
  {
    text: "Use ",
    code: ".badge-l- ",
  },
  {
    text: "classes to provide background-colors and",
    code: "vr ",
  },
  {
    text: "classes to partitions.",
  },
];

export const BadgesData = [
  {
    id: 1,
    color: "primary",
    text: "Primary",
  },
  {
    id: 2,
    color: "secondary",
    text: "Secondary",
  },
  {
    id: 3,
    color: "success",
    text: "Success",
  },
  {
    id: 4,
    color: "info",
    text: "Info",
  },
  {
    id: 5,
    color: "warning",
    text: "Warning",
  },
  {
    id: 6,
    color: "danger",
    text: "Danger",
  },
  {
    id: 7,
    color: "light text-dark",
    text: "Light",
  },
  {
    id: 8,
    color: "dark",
    text: "Dark",
  },
];

export const OutlineBadgesData = [
  {
    id: 1,
    badgeClass: "badge-b-primary txt-primary",
    text: "Primary",
  },
  {
    id: 2,
    badgeClass: "badge-b-secondary txt-secondary",
    text: "Secondary",
  },
  {
    id: 3,
    badgeClass: "badge-b-success txt-success",
    text: "Success",
  },
  {
    id: 4,
    badgeClass: "badge-b-info txt-info",
    text: "Info",
  },
  {
    id: 5,
    badgeClass: "badge-b-warning txt-warning",
    text: "Warning",
  },
  {
    id: 6,
    badgeClass: "badge-b-danger txt-danger",
    text: "Danger",
  },
  {
    id: 7,
    badgeClass: "badge-b-light txt-dark",
    text: "Light",
  },
  {
    id: 8,
    badgeClass: "badge-b-dark txt-dark",
    text: "Dark",
  },
];

export const BadgeIconData = [
  {
    id: 1,
    color: "primary",
    iconName: <DollarSign />,
  },
  {
    id: 2,
    color: "secondary",
    iconName: <Headphones />,
  },
  {
    id: 3,
    color: "success",
    iconName: <Link2 />,
  },
  {
    id: 4,
    color: "info",
    iconName: <GitHub />,
  },
  {
    id: 5,
    color: "warning",
    iconName: <Award />,
  },
  {
    id: 6,
    color: "danger",
    iconName: <Activity />,
  },
  {
    id: 7,
    color: "light text-dark",
    iconName: <Heart />,
  },
  {
    id: 8,
    color: "dark",
    iconName: <Mail />,
  },
];

export const BadgeButtonData = [
  {
    class: "primary",
    text: "Messages",
    iconName: <Mail />,
  },
  {
    class: "secondary",
    text: "notifications",
    iconName: <Bell />,
  },
  {
    class: "success",
    text: "Update available",
    iconName: <Settings />,
  },
  {
    class: "info",
    text: "Playing Now",
    iconName: <Music />,
  },
  {
    class: "warning",
    text: "1.2 GB Used",
    iconName: <AlertTriangle />,
  },
];

export const PositionedBadgesData = [
  { title: "Inbox", color: "primary", text: "99+" },
  { color: "info", text: "8", icon: "twitter", buttonClass: "badge-square" },
  { title: "Profile", color: "primary", badgesClass: "border border-light rounded-circle badge-p-5" },
  { color: "info", icon: "linkedin", buttonClass: "badge-square", badgesClass: "badge-p-5 border border-light rounded-circle" },
  { color: "success", icon: "wechat", buttonClass: "badge-square", badgesClass: "badge-p-5 border border-light rounded-circle" },
  { color: "info", icon: "twitter", buttonClass: "badge-square", badgesClass: "badge-p-5 border border-light rounded-circle" },
];

export const ButtonBadgesData = [
  { title: "Notifications", text: "4", color: "primary" },
  { title: "Sale", text: "9", buttonClass: "button-light-primary", badgesClass: "rounded-pill", color: "transparent" },
  { title: "Instagram", text: "6", buttonClass: "border-dashed-primary", color: "transparent" },
  { title: "LinkedIn", text: "3", buttonClass: "btn-pill button-light-info txt-info", badgesClass: "text-bg-info rounded-pill txt-light", color: "transparent" },
];

export const ImageBadgesData = [
  {
    id: 1,
    color: "primary",
    image: "user/1.png",
  },
  {
    id: 2,
    color: "secondary",
    image: "user/2.png",
  },
  {
    id: 3,
    color: "success",
    image: "user/3.png",
  },
  {
    id: 4,
    color: "danger",
    image: "user/4.png",
  },
  {
    id: 5,
    color: "warning",
    image: "user/5.png",
  },
  {
    id: 6,
    color: "info",
    image: "user/6.png",
  },
  {
    id: 7,
    color: "light",
    image: "user/7.png",
  },
  {
    id: 8,
    color: "dark",
    image: "user/16.png",
  },
];
